import { __read } from "tslib";
import { useState, useEffect } from 'react';
export var useRowsGroupSelection = function (_a) {
    var enabled = _a.enabled;
    var _b = __read(useState(null), 2), selectionOffset = _b[0], setSelectionOffset = _b[1];
    var getSelectionOffsetRange = function (rowId) {
        var parsedRowId = parseInt(rowId);
        var parsedSelectionOffset = parseInt(selectionOffset);
        var startOffset = parsedRowId > parsedSelectionOffset ? parsedSelectionOffset : parsedRowId;
        var endOffset = parsedSelectionOffset > parsedRowId ? parsedSelectionOffset : parsedRowId;
        if (startOffset === endOffset)
            return null;
        return new Array(endOffset - startOffset + 1)
            .fill(startOffset)
            .map(function (offset, idx) { return (offset + idx).toString(); });
    };
    useEffect(function () {
        if (enabled) {
            var eventListener_1 = function (e) {
                if (e.key === 'Shift')
                    setSelectionOffset(null);
            };
            document.addEventListener('keyup', eventListener_1);
            return function () { return document.removeEventListener('keyup', eventListener_1); };
        }
    }, [enabled]);
    return {
        getSelectionOffsetRange: getSelectionOffsetRange,
        setSelectionOffset: setSelectionOffset,
        selectionOffset: selectionOffset,
    };
};
